import { render, staticRenderFns } from "./CheckFrequencia.vue?vue&type=template&id=99986a88&"
import script from "./CheckFrequencia.vue?vue&type=script&lang=js&"
export * from "./CheckFrequencia.vue?vue&type=script&lang=js&"
import style0 from "./CheckFrequencia.vue?vue&type=style&index=0&id=99986a88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports